export default {
  PARTNER: 'partner',
  TRADER: 'trader',
  MANAGER: 'manager',
};
